import type {SystemProps} from '@chakra-ui/styled-system';
import {cssVar} from '@chakra-ui/styled-system';
import type {StyleFunctionProps} from '@chakra-ui/theme-tools';
import {mode} from '@chakra-ui/theme-tools';

import {prefix} from '../design-tokens/light';

import {scroller} from './scroller';

const $background = cssVar(`${prefix}-colors-background-body`);
const $text = cssVar(`${prefix}-colors-text-base`);
const $textMuted = cssVar(`${prefix}-colors-text-muted`);

export const global = (props: StyleFunctionProps) => {
  return {
    body: {
      [$background.variable]: `background.primary`,
      [$text.variable]: mode(`black`, `white`)(props),
      color: $text.reference,
      bg: $background.reference,
      ...scroller(props.theme),
    } satisfies SystemProps,
    '*::placeholder': {
      opacity: 1,
      color: $textMuted.reference,
    },
    '*, *::before, &::after': {
      borderColor: mode(`gray.200`, `gray.500`)(props),
    },
    '::selection': {
      backgroundColor: `#1f64ff`,
      color: `white`,
    },
    'html,body': {
      height: `100%`,
    },
    '#__next, #root': {
      display: `flex`,
      flexDirection: `column`,
      minH: `100%`,
    },
    a: {
      fontWeight: `inherit`,
      _hover: {
        textDecoration: `underline`,
      },
    },
  };
};
